import { Badge, EmptyValuePlaceholder } from '@/components/ui'

export const statusColor = (status) => ["loué", "en vente"].includes(status) ? "info" :
    ["vendu"].includes(status) ? "error" :
    "warning" 

export const containerStatusStyle = (status) => {

  const borderColorClasses = {
    info: "border-l-primary",
    success: "border-l-success",
    warning: "border-l-warning",
    error: "border-l-error"
  }

  const fromColorClasses = {
    info: "from-sky-50",
    success: "from-green-50",
    warning: "from-amber-50",
    error: "from-red-50"
  }

  return `border-l-1 ${borderColorClasses[statusColor(status)]} bg-gradient-to-r ${fromColorClasses[statusColor(status)]} from-2% to-primary-100 to-10%`
}

export default ({status, size = "md", className = ""}) => status && status === "loué" ? 
  <Badge color={statusColor(status)} text={status} size={size} className={className} /> :
  <EmptyValuePlaceholder />